module.exports = __webpack_public_path__ + "images/7edd8a29f15446bd431e637b37f223775.svg";